import { HIDE_LOADING } from './types'



export const hideLoading = () => dispatch => {
   
    dispatch({
        type: HIDE_LOADING, 
        payload: false
    })
}


// WEBPACK FOOTER //
// ./src/Actions/loadingAction.js